/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Tab_Pages_Used_UpInputs */



/**
* | output |
* | --- |
* | "You've used all included pages this month. New documents will be processed as capacity allows." |
*
* @param {Usage_Tab_Pages_Used_UpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_tab_pages_used_up = /** @type {((inputs?: Usage_Tab_Pages_Used_UpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Tab_Pages_Used_UpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie haben alle enthaltenen Seiten diesen Monat genutzt. Neue Dokumente werden im Rahmen der verfügbaren Kapazität verarbeitet.")
	return /** @type {LocalizedString} */ ("You've used all included pages this month. New documents will be processed as capacity allows.")
});